import SaleRateIndexingRule from './SaleRateIndexingRule.vue';

export const saleRateIndexingRuleRoutes = [
  { path: 'sale-rate-indexing-rule', component: SaleRateIndexingRule, name: 'sale-rate-indexing-rule' }
];
